import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export interface IAbortOTPVariables {
    id: number;
    reasonCode: number;
    reasonText?: string;
}

export function useAbortOTP(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, IAbortOTPVariables>({
        mutationKey: [QueryKeys.otp, 'abort'],
        mutationFn: async ({ id, reasonCode, reasonText }: IAbortOTPVariables) => {
            return await OTPApi.abortOTP(id, reasonCode, reasonText);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId) 
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });
            
            notifications.show({
                title: t('otp.notifications.abortSuccess.title'),
                message: t('otp.notifications.abortSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.abortError.title'),
                message: error?.message || t('otp.notifications.abortError.message'),
                color: 'red',
            });
        },
    });
}
